import React from 'react';

export default function ProjectedStartersTable({ managerPlayerData }) {
    const sortedManagerPlayerData = managerPlayerData.sort((a, b) => {
        return (a.yahooleaguerank || 9999) - (b.yahooleaguerank || 9999);
    });
    return (
        <table className="table table-dark table-striped table-bordered caption-top">
            <thead>
                <tr>
                    <th>Pos</th>
                    <th>Player</th>
                    <th>Y!</th>
                </tr>
            </thead>
            <tbody>
                {[
                    { label: "QB", count: 1, filter: p => p.posname === "QB" },
                    { label: "RB", count: 2, filter: p => p.posname === "RB" },
                    { label: "WR", count: 2, filter: p => p.posname === "WR" },
                    { label: "TE", count: 1, filter: p => p.posname === "TE" },
                    { label: "Flex", count: 2, filter: p => ["RB", "WR", "TE"].includes(p.posname) },
                    { label: "K", count: 1, filter: p => p.posname === "K" },
                    { label: "D/ST", count: 1, filter: p => p.posname === "D/ST" }
                ].map((slot, i) => {
                    // For Flex, skip players already used in RB/WR/TE slots
                    let usedIds = [];
                    if (slot.label === "Flex") {
                        usedIds = [].concat(
                            sortedManagerPlayerData.filter(p => p.posname === "RB").slice(0,2),
                            sortedManagerPlayerData.filter(p => p.posname === "WR").slice(0,2),
                            sortedManagerPlayerData.filter(p => p.posname === "TE").slice(0,1)
                        ).map(p => p.id);
                    }
                    let available = sortedManagerPlayerData.filter(p => slot.filter(p) && (slot.label !== "Flex" || !usedIds.includes(p.id)));
                    let rows = [];
                    for (let j = 0; j < slot.count; j++) {
                        const player = available[j];
                        rows.push(
                            <tr key={slot.label + j}>
                                <td>{slot.label}</td>
                                <td>{player ? player.name : "-"}</td>
                                <td>{player ? (player.yahooleaguerank || "-") : "-"}</td>
                            </tr>
                        );
                    }
                    return rows;
                })}
                {/* TODO, needs work, choose only sterters, then probably refactor this whole component */}
                {/* <tr>
                    <td colSpan={2}><b>Avg Yahoo Rank of starters</b></td>
                    <td>
                        {sortedManagerPlayerData.filter(p => ["QB", "RB", "WR", "TE", "K", "D/ST"].includes(p.posname))
                            .reduce((sum, p) => sum + (p.yahooleaguerank || 0), 0) / 
                            sortedManagerPlayerData.filter(p => ["QB", "RB", "WR", "TE", "K", "D/ST"].includes(p.posname)).length || "-"}
                    </td>
                </tr> */}
            </tbody>
        </table>
    )
}